<template>
  <div>
    <div>
      Choose an online submission to assign to {{ isStudent ? student.fullName:staff.fullName }} for
      requirement "{{ requirement.name }}"
    </div>
    <v-divider class="my-2" />
    <!-- <div class="d-flex">
      <v-text-field class="mx-2" label="Search" :placeholder="`Search by ${isStudent ? 'student or guardian':'staff'} name`"/>
      <v-btn class="my-auto ml-2" > Search </v-btn>
    </div> -->
    <infinite-scroll
      :key="infiniteScrollKey"
      @fetchData="fetchData"
      :totalPages.sync="totalPages"
    >
      <v-row ref="submissionlist" dense>
        <v-col cols="12">
          <div class="text-subtitle-2 ml-2 text-center font-weight-light">
            {{ totalSizes ? totalSizes : 0 }} Unassigned Submissions found
          </div>
        </v-col>
        <v-col
          v-for="submission in submissions"
          :key="submission.id"
          cols="12"
          lg="4"
          md="6"
        >
          <v-sheet :elevation="2" class="ma-2 pa-4" :height="150">
            <div class="d-flex flex-row justify-space-between">
              <div>
                <div v-if="submission.studentId">
                  Student: {{ submission.studentName }}
                </div>
                <div v-if="submission.rpId">
                  Guardian: {{ submission.rpName }}
                </div>
                <div class="text-caption">
                  Submitted on {{ submission.submittedAt | formatDateTime }}
                </div>
              </div>
              <div>
                <v-btn
                  @click="viewSubmissionDetails(submission.id)"
                  color="primary"
                  text
                  >View</v-btn
                >
              </div>
            </div>
            <v-btn @click="selectedSubmission(submission)" class="mt-4" width="100%">Select</v-btn>
          </v-sheet>
        </v-col>
      </v-row>
    </infinite-scroll>
    <v-bottom-sheet
      scrollable
      v-if="selectedSubmissionId"
      v-model="submissionDetailsDialog"
    >
      <v-card>
        <v-card-actions class="justify-center">
          <v-btn class="mt-2" @click="submissionDetailsDialog = false" text>Close</v-btn>
        </v-card-actions>
        <v-card-title>Submitted Answers</v-card-title>
        <v-card-text>
          <form-response-details
            :key="selectedSubmissionId"
            :submissionId="selectedSubmissionId"
          />
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapActions } from "vuex";
const FormResponseDetails = () =>
  import("@/components/forms/FormResponseDetails.vue");

export default {
  props: {
    requirement: {
      type: Object,
      require: true,
    },
    student: {
      type: Object,
      require: false
    },
    staff: {
      type: Object,
      require: false
    }
  },
  components: { FormResponseDetails },
  data: () => ({
    submissions: [],
    searchTerms: "",
    infiniteScrollKey: Date.now(),
    totalPages: null,
    totalSizes: null,
    submissionDetailsDialog: false,
    selectedSubmissionId: null,
    isStudent: false,
  }),
  mounted() {
    this.isStudent = this.student ? true: false;
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addSuccessMessage",
      "clearMessage",
    ]),

    fetchData({ page, done, empty }) {
      const params = {
        page,
        size: 5,
        sort: "id,desc",
        search_terms: this.searchTerms,
      };
      this.$axios
        .get("/form-submission/requirement/" + this.requirement.requirementId, {
          params,
        })
        .then((resp) => {
          this.submissions = this.submissions.concat(resp.data.content);
          this.totalPages = resp.data.totalPages;
          this.totalSizes = resp.data.totalElements;
          if (this.totalSizes > 0) {
            done();
          } else {
            empty();
          }
        })
        .catch((error) => {
          this.addErrorMessage(
            error.message || "Error retrieving online submissions"
          );
        });
    },
    search() {
      this.infiniteScrollKey = Date.now();
    },
    clearSearch() {
      this.searchTerms = null;
      this.infiniteScrollKey = Date.now();
    },
    viewSubmissionDetails(id) {
      this.submissionDetailsDialog = true;
      this.selectedSubmissionId = id;
    },
    selectedSubmission(submission){
        this.$emit('selected', {submission, requirement: this.requirement})
    }
  },
};
</script>

<style>
</style>